export default __webpack_public_path__ + "static/media/Levitate Final Technical Report.edc496aa.pdf";